import { Col, Container, Image, Row } from "react-bootstrap";
import { motion } from "framer-motion";

import { ColorsStyle } from "../../config/colors";

export default function LandingComunidade(){

	return (
		<Container fluid id="comunidade" className="py-5 overflow-hidden">
			<Container>
				<div className="mb-5 fs-1 text-white fw-bold text-center">O que rola na nossa comunidade</div>
					<Row className="d-none d-lg-flex">
						<Col lg={4}>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_6.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/460, objectPosition: 'top'}}/>
							</motion.div>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_2.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/550, objectPosition: 'top'}}/>
							</motion.div>
						</Col>

						<Col lg={4}>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_1.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/630, objectPosition: 'top'}}/>
							</motion.div>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_5.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/450, objectPosition: 'top'}}/>
							</motion.div>
						</Col>

						<Col lg={4}>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_3.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/460, objectPosition: 'top'}}/>
							</motion.div>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_4.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/480, objectPosition: 'top'}}/>
							</motion.div>
						</Col>
					</Row>

					<Row className="d-flex d-lg-none">
						<Col lg={4}>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_1.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/630, objectPosition: 'top'}}/>
							</motion.div>
						</Col>

						<Col lg={4}>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_3.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/460, objectPosition: 'top'}}/>
							</motion.div>
						</Col>

						<Col lg={4}>
							<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} className="d-flex flex-row mb-4 p-2 rounded-3 fs-4" style={{backgroundColor: ColorsStyle.Grey700}}>
								<Image src={process.env.PUBLIC_URL + "images/comunidade_4.webp"} loading="lazy" style={{objectFit: 'cover', width: "100%", aspectRatio: 400/480, objectPosition: 'top'}}/>
							</motion.div>
						</Col>
					</Row>
			</Container>
		</Container>
	)
}